import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorRewardsHub = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#F7A600" d="M10.5 14h3v7h-3v-7Z" />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M13.541 6.25H15.5L16.55 5a.75.75 0 1 0-1.15-.965L13.542 6.25Zm3.916 0H20c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 20 11.75h-.25v7.75a2.25 2.25 0 0 1-2.25 2.25h-11a2.25 2.25 0 0 1-2.25-2.25v-7.75H4A1.75 1.75 0 0 1 2.25 10V8c0-.966.784-1.75 1.75-1.75h2.735l-.241-.287a2.25 2.25 0 1 1 3.447-2.892l2.155 2.568L14.25 3.07a2.25 2.25 0 0 1 3.447 2.892l-.24.287Zm-8.764 0h1.958L8.792 4.035a.75.75 0 1 0-1.149.964l1.05 1.251Zm-4.443 4H20a.25.25 0 0 0 .25-.25V8a.25.25 0 0 0-.25-.25H4a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h.25Zm1.5 1.5v7.75c0 .414.336.75.75.75h11a.75.75 0 0 0 .75-.75v-7.75H5.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorRewardsHub;
